import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Sentry } from '@/lib/sentry';
import { NetworkErrorPage } from '@/pages/NetworkErrorPage';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('ErrorBoundary caught:', error);
        Sentry.captureException(error, {
            contexts: {
                react: { componentStack: errorInfo.componentStack ?? undefined },
            },
        });
    }

    render() {
        if (this.state.hasError) return <NetworkErrorPage />;
        return this.props.children;
    }
}
